import styled from 'styled-components';
import { theme } from '../../global';

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
`;

export const SelectWithLabel = styled.div`
  position: relative;
  width: 204px;
  height: 48px;

  .ant-select {
    width: 100%;

    .ant-select-selector {
      border: none !important;
      box-shadow: none !important;
      padding: 0 12px;
      height: 48px !important;
      display: flex;
      align-items: center;
      position: relative;
      width: 204px;
    }

    /* Контейнер для текста */
    .ant-select-selection-wrap {
      display: flex;
      align-items: center;
      width: 100%;
      height: 100%;
      margin-top: 12px !important;
      justify-content: flex-start;
      padding-left: 0 !important;
      margin-left: 36px !important; 
    }

    .ant-select-selection-item {
      display: flex;
      align-items: center;
      width: 100%;
      text-align: left;
      padding: 0 !important;
      justify-content: flex-start;
    }

    .ant-select-selection-placeholder {
      display: flex;
      align-items: center;
      width: 100%;
      text-align: left;
      padding: 0 !important;
      justify-content: flex-start;
    }

    /* Скрываем поисковый инпут */
    .ant-select-selection-search {
      position: absolute;
      width: 0;
      height: 0;
      opacity: 0;
    }

    /* Префикс иконка */
    .ant-select-prefix {
      position: absolute;
      left: 12px;
      top: 24px !important;
      transform: translateY(-50%);
      z-index: 2;
    }

    /* Суффикс иконка (стрелка) */
    .ant-select-arrow {
      position: absolute;
      right: 12px;
      top: 24px !important;
      transform: translateY(-50%);
      margin: 0 !important;
      z-index: 2;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .floating-label {
    position: absolute;
    top: 8px;
    left: 44px;
    background: white;
    padding: 0 4px;
    font-size: 12px;
    color: #666;
    z-index: 3;
    font-weight: 500;
    pointer-events: none;
  }
`;
